import axios from 'axios';
import { BASE_API } from '../../../Shared/Constants';


export function login(body) {
    const credentials = btoa("R3pKSTV4UkFTdjhKZHQvOFlEVzNOSmViSmpyZHNFTUIxSzZRN0hjPQ==:")
    return axios.post(BASE_API+'api/login', {
            user:body.user,
            passW:body.password
    }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Basic UjNwS1NUVjRVa0ZUZGpoS1pIUXZPRmxFVnpOT1NtVmlTbXB5WkhORlRVSXhTelpSTjBoalBRPT06`
        }
    })
    .then(function(response) {
        return response;
    })
    .catch(function(error) {
        console.log(error)
        return error;
    });
}
